export default __webpack_public_path__ + "static/media/ce4.e46a2a22.png";